import styled, { css } from 'styled-components';

import { spaceMixin } from '@zillow/constellation';

import {
    Container,
} from '@zillow/zrs-comet';

export const StyledBreadcrumb = styled.div`
    .Breadcrumb {
        padding-left: 0;
        padding-right: 0;
    }
`;

export const StyledPhotoTabsSkeletonContainer = styled.div`
    border: 1px solid #d1d1d5;

    && .Tabs-list {
        margin-bottom: 0;
        padding: 12px 32px 2px 32px;
    }
`;

/* FIX: update breakpoints once we implement new HeaderNav that includes zrs-comet Grid componente */
export const StyledContainer = styled(Container)`
    ${props => props.theme.ns().media.getMediaQuery('(min-width: 600px)', css`
            padding-left: ${spaceMixin('lg')};
            padding-right: ${spaceMixin('lg')};
    `)};
`;
